<template>
  <div class="print">
    <!-- 1. 헤더 및 결재란 -->
    <section class="section-approval">
      <div class="header-left-area">
        <p class="print-title">{{ $t('노사협의체') }}</p>
        <div class="division-title mt-10">□ {{ $t('기본정보') }}</div>
      </div>

      <table class="table-approval-field mt-auto">
        <colgroup>
          <col width="38" />
          <col width="112" />
          <col width="112" />
          <col width="112" />
          <col width="112" />
        </colgroup>
        <tr>
          <th rowspan="2" class="gray p-0">
            <div class="flex justify-center items-center">
              <p style="writing-mode: vertical-lr">{{ $i18n.locale === 'ko' ? $t('결&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;재') : $t('결재') }}</p>
            </div>
          </th>
          <th class="gray">{{ $t('작성자') }}</th>
          <th class="gray">{{ $t('검토자') }}</th>
          <th class="gray">{{ $t('회람자') }}</th>
          <th class="gray">{{ $t('승인자') }}</th>
        </tr>
        <tr>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" class="signature-image" />
              <p v-else-if="form.sign1.name" class="name-text">{{ form.sign1.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign2.sign" :src="form.sign2.sign" class="signature-image" />
              <p v-else-if="form.sign2.name" class="name-text">{{ form.sign2.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign3.sign" :src="form.sign3.sign" class="signature-image" />
              <p v-else-if="form.sign3.name" class="name-text">{{ form.sign3.name }}</p>
            </div>
          </td>
          <td style="vertical-align: middle; height: 80px;">
            <div class="signature-container">
              <img v-if="form.sign4.sign" :src="form.sign4.sign" class="signature-image" />
              <p v-else-if="form.sign4.name" class="name-text">{{ form.sign4.name }}</p>
            </div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 2. 기본 정보 -->
    <section class="section-stdInfo mb-5">
      <table class="w-full">
        <colgroup>
          <col width="140" />
          <col />
          <col width="140" />
          <col />
        </colgroup>
        <tr>
          <th>{{ $t('회사명') }}</th>
          <td colspan="3">
            <div class="text-left px-2"> {{ form.stdInfo.field_name }} </div>
          </td>
        </tr>
        <tr>
          <th>{{ $t('작성자') }}</th>
          <td>
            <div class="px-2"> {{ form.stdInfo.writer_name }} </div>
          </td>
          <th>{{ $t('작성일') }}</th>
          <td>
            <div class="px-2"> {{ form.stdInfo.date }} </div>
          </td>
        </tr>
      </table>
    </section>

    <!-- 3. 협의체 정보 -->
    <section class="section-council mb-5">
      <div class="division-title">□ {{ $t('협의체 정보') }}</div>
      <table class="w-full">
        <colgroup>
          <col width="140" />
          <col />
          <col width="140" />
          <col />
        </colgroup>
        <tr>
          <th>{{ $t('협의일') }}</th>
          <td>{{ form.inputA_2 }}</td>
          <th>{{ $t('회의장소') }}</th>
          <td>{{ form.inputA_3 }}</td>
        </tr>
        <tr>
          <th>{{ $t('노측 위원(명)') }}</th>
          <td>{{ form.inputA_4 }} 명</td>
          <th>{{ $t('사측 위원(명)') }}</th>
          <td>{{ form.inputA_5 }} 명</td>
        </tr>
      </table>
    </section>

    <!-- 4. 사측 위원(사용자) 명단 -->
    <section class="section-commitee-user mb-5">
      <div class="division-title">□ {{ $t('사측 위원(사용자)') }}</div>
      <table class="w-full">
        <colgroup>
          <col width="180" />
          <col width="140" />
          <col width="120" />
          <col width="120" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t('소속명') }}</th>
            <th>{{ $t('직책') }}</th>
            <th>{{ $t('이름') }}</th>
            <th>{{ $t('서명') }}</th>
            <th>{{ $t('비고') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="form.userTableList.length === 0">
            <td colspan="5" class="p-4">{{ $t('작성된 내용이 없습니다.') }}</td>
          </tr>
          <template v-else>
            <tr v-for="(item, index) in form.userTableList" :key="'user_'+index">
              <td>{{ item.cell1 }}</td>
              <td>{{ item.cell2 }}</td>
              <td>{{ item.cell3 }}</td>
              <td style="height: 60px; vertical-align: middle;">
                <div class="signature-container" style="height: 50px;">
                  <img v-if="item.cell4" :src="item.cell4" class="signature-image" style="max-height: 40px;" />
                </div>
              </td>
              <td class="text-left font-14">{{ item.cell5 }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </section>

    <!-- 5. 노측 위원(근로자) 명단 -->
    <section class="section-commitee-worker mb-5">
      <div class="division-title">□ {{ $t('노측 위원(근로자)') }}</div>
      <table class="w-full">
        <colgroup>
          <col width="180" />
          <col width="140" />
          <col width="120" />
          <col width="120" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t('소속명') }}</th>
            <th>{{ $t('직책') }}</th>
            <th>{{ $t('이름') }}</th>
            <th>{{ $t('서명') }}</th>
            <th>{{ $t('비고') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="form.workerTableList.length === 0">
            <td colspan="5" class="p-4">{{ $t('작성된 내용이 없습니다.') }}</td>
          </tr>
          <template v-else>
            <tr v-for="(item, index) in form.workerTableList" :key="'worker_'+index">
              <td>{{ item.cell1 }}</td>
              <td>{{ item.cell2 }}</td>
              <td>{{ item.cell3 }}</td>
              <td style="height: 60px; vertical-align: middle;">
                <div class="signature-container" style="height: 50px;">
                  <img v-if="item.cell4" :src="item.cell4" class="signature-image" style="max-height: 40px;" />
                </div>
              </td>
              <td class="text-left font-14">{{ item.cell5 }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </section>

    <!-- 6. 협의내용 상세 -->
    <section class="section-meeting-detail mb-5">
      <div class="division-title">□ {{ $t('노·사협의체(심의·의결사항, 안전계획 등) 협의내용') }}</div>
      <table class="w-full">
        <colgroup>
          <col width="240" />
          <col />
        </colgroup>
        <tr>
          <th>{{ $t('대상기간') }}</th>
          <td class="text-left">{{ form.inputB_1 }} ~ {{ form.inputB_2 }}</td>
        </tr>
        <tr>
          <th>{{ $t('재해형태') }}</th>
          <td class="text-left">{{ $t(form.inputB_3) }}</td>
        </tr>
        <tr>
          <th>{{ $t('작업시간') }}</th>
          <td class="text-left">{{ form.inputB_8 }}</td>
        </tr>
        <tr>
          <th>{{ $t('노·사협의체 구성') }}</th>
          <td class="text-left">{{ form.inputB_4 }}</td>
        </tr>
        <tr>
          <th>{{ $t('노·사협의체 운영') }}</th>
          <td class="text-left">{{ form.inputB_5 }}</td>
        </tr>
        <tr>
          <th>{{ $t('노·사합동안전점검') }}</th>
          <td class="text-left">{{ form.inputB_7 }}</td>
        </tr>
        <tr>
          <th>{{ $t('작업장 간의 연락방법') }}</th>
          <td class="text-left">{{ form.inputB_9 }}</td>
        </tr>
        <tr>
          <th>{{ $t('산업재해 예방계획 수립에 관한 사항') }}</th>
          <td class="text-left">{{ form.inputB_10 }}</td>
        </tr>
        <tr>
          <th>{{ $t('안전보건관리규정 작성 및 변경 사항') }}</th>
          <td class="text-left">{{ form.inputB_11 }}</td>
        </tr>
        <tr>
          <th>{{ $t('근로자의 안전보건교육 사항') }}</th>
          <td class="text-left">{{ form.inputB_12 }}</td>
        </tr>
      </table>
    </section>

    <!-- 7. 사진대지 -->
    <section class="section-photo" v-if="form.photoList && form.photoList.length > 0">
      <div class="division-title">□ {{ $t('사진대지') }}</div>
      <div class="photo-grid">
        <div v-for="(photo, index) in form.photoList" :key="index" class="photo-item">
          <div class="photo-box">
            <img v-if="photo.path" :src="photo.path" class="grid-photo" />
          </div>
          <div class="photo-desc">{{ photo.input }}</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Print",
  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  }
};
</script>

<style lang="scss" scoped>
.print {
  .signature-container {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px;

    .signature-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 70px;
      object-fit: contain;
      display: block;
    }
    .name-text {
      font-size: 16px;
      margin-top: 5px;
    }
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;

    th, td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
      padding: 10px;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
    }
    td {
      word-break: break-all;
    }
    .gray {
      background-color: #ececec;
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
      word-break: break-word;
    }
    .font-14 {
      font-size: 14px;
    }
  }

  .section-approval {
    display: grid;
    grid-template-columns: 1fr auto;
    width: 100%;
    align-items: flex-start;

    .header-left-area {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      padding-top: 20px;

      .print-title {
        font-size: 32px;
        font-weight: bold;
        color: #000;
        text-align: center;
        margin-bottom: 20px;
      }
    }

    .table-approval-field {
      width: auto;
      margin-left: 10px;
      tr:last-child { th, td { border-bottom: 1px solid #757575; } }
    }
  }

  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3C3C3C;
    padding: 1.25rem 0rem;
  }

  .photo-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    width: 100%;
  }
  .photo-item {
    border: 1px solid #757575;
    display: flex;
    flex-direction: column;
  }
  .photo-box {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #757575;
    padding: 10px;
    background: #f9f9f9;

    .grid-photo {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  .photo-desc {
    padding: 10px;
    font-size: 16px;
    min-height: 50px;
    text-align: left;
    background: #fff;
  }
}

@media print {
  section {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  .photo-item {
    page-break-inside: avoid;
  }
}
</style>
